import { useParams } from "react-router-dom";
import { db } from "../firebase";
import { createContext, useReducer, useEffect, useContext } from "react";
import { LoaderDisbatch } from "./loader";
export const StylesValue = createContext(null);
export const StylesDisbatch = createContext(null);

const reducer = (state, action) => {
  const newState = { ...state };
  if (action.type === "set") {
    return action.value;
  }
};

export default function StylesContext({ children }) {
  const [state, dispatch] = useReducer(reducer, []);
  const { appId, type, pageId } = useParams();
  const setLoader = useContext(LoaderDisbatch);

  useEffect(() => {
    if (appId && pageId) {
      db.collection("apps")
        .doc(appId)
        .collection("styles")
        .orderBy("name")
        .onSnapshot((snap) => {
          const styles = snap.docs.map((doc) => {
            return { ...doc.data(), id: doc.id };
          });
          dispatch({ type: "set", value: styles });
          setLoader(false);
        });
    }
  }, [appId, pageId]);

  //   useEffect(() => {
  //     if (appId && pageId && state) {
  //       db.collection("apps")
  //         .doc(appId)
  //         .collection("styles")
  //         .doc(pageId)
  //         .set(state, { merge: true });
  //     }
  //   }, [state]);

  return (
    <StylesValue.Provider value={state}>
      <StylesDisbatch.Provider value={dispatch}>
        {children}
      </StylesDisbatch.Provider>
    </StylesValue.Provider>
  );
}
